import { Dispatch, SetStateAction, useState } from 'react';

import { IPart, IPartAutocomplete } from 'partsOld/types';

import PartInfoView from './PartInfoView';

interface IProps {
  part: Partial<IPart>;
  setSelectedPart?: Dispatch<SetStateAction<IPartAutocomplete>>;
  isEditable?: boolean;
  selectedPart?: IPartAutocomplete;
  onAddPart?: () => void;
}

const PartInfo = ({
  part,
  setSelectedPart,
  isEditable = true,
  selectedPart,
  onAddPart,
}: IProps) => {
  const [isEditMode, setIsEditMode] = useState(isEditable && !(part || selectedPart));

  const searchPart = () => {
    if (!part && !selectedPart) {
      return;
    }

    onAddPart();
    setIsEditMode(false);
  };

  return (
    <PartInfoView
      part={part || selectedPart}
      setSelectedPart={setSelectedPart}
      isEditMode={isEditMode}
      setIsEditMode={setIsEditMode}
      isEditable={isEditable}
      selectedPart={selectedPart}
      searchPart={searchPart}
    />
  );
};

export default PartInfo;
